<template>
  <div>
    <v-app class="mt-1">
      <v-main class="custom__bg">
        <v-container>
          <v-row>
            <!-- Left Column -->
            <v-col cols="12" md="3" class="hidden-sm-and-down" lg="3">
              <v-col cols="12" class="py-1">
                <v-card class="text-center premium-card" max-width="300" max-height="160">
                  <v-card-text>
                    <v-avatar size="60" class="elevation-3" style="border: 2px solid #f69227">
                      <img :src="$root.store.getUserAvatar()" alt="Profile Picture" />
                    </v-avatar>
                    <div class="mt-3 black--text">
                      <h2 style="font-size: 17px; font-weight: 700">{{ $root.storeState.currentUser.name || 'Student' }}</h2>
                      <p style="font-size: 12px; color: #707070">{{ $root.storeState.currentUser.school || 'Not specified' }}</p>
                    </div>
                  </v-card-text>
                </v-card>
              </v-col>
              <LeftMenu />
            </v-col>

            <!-- Center Column (Feed) -->
            <v-col cols="12" sm="12" md="6" lg="6" class="py-1">
              <!-- Hero Banner -->
              <v-col cols="12" md="12" class="px-0">
                <v-card class="premium-card overflow-hidden" style="background: linear-gradient(135deg, #f69227 0%, #ff6f3c 100%)">
                  <v-card-text class="white--text pa-5">
                    <h2 style="font-size: 20px; font-weight: 700" class="mb-1">Welcome back, {{ firstName }}! 👋</h2>
                    <p style="font-size: 13px; opacity: 0.9" class="mb-0">Continue learning and share your knowledge with the community</p>
                  </v-card-text>
                </v-card>
              </v-col>

              <!-- Quick Stats -->
              <v-col cols="12" class="px-0 py-2">
                <v-row no-gutters>
                  <v-col cols="4" class="pr-1">
                    <v-card class="premium-card text-center pa-3">
                      <div class="font-weight-bold" style="color: #f69227; font-size: 20px">{{ $root.storeState.stats.quizzes }}</div>
                      <div class="caption grey--text">Quizzes Taken</div>
                    </v-card>
                  </v-col>
                  <v-col cols="4" class="px-1">
                    <v-card class="premium-card text-center pa-3">
                      <div class="font-weight-bold" style="color: #43a047; font-size: 20px">{{ $root.storeState.stats.score }}%</div>
                      <div class="caption grey--text">Avg Score</div>
                    </v-card>
                  </v-col>
                  <v-col cols="4" class="pl-1">
                    <v-card class="premium-card text-center pa-3">
                      <div class="font-weight-bold" style="color: #2089d6; font-size: 20px">{{ $root.storeState.stats.groups }}</div>
                      <div class="caption grey--text">Groups</div>
                    </v-card>
                  </v-col>
                </v-row>
              </v-col>

              <!-- Post Box -->
              <v-col cols="12" md="12" class="px-0 py-1">
                <v-card class="pa-4 premium-card">
                  <v-card flat height="42" style="border-radius: 30px; cursor: pointer" color="#f5f5f5" class="d-flex align-center px-2 hover-scale" @click="postDialog = true">
                    <v-btn rounded icon elevation="1" small color="white" style="background-color: #f69227">
                      <v-icon color="white" size="18">mdi-pencil</v-icon>
                    </v-btn>
                    <span class="pl-3 font-weight-medium grey--text text--darken-1" style="font-size: 14px">Share a lecture, video, or thought...</span>
                  </v-card>
                </v-card>
              </v-col>

              <!-- Feed Posts (Scrollable) -->
              <div class="feed-scroll-container pb-10">
                <v-col
                  cols="12"
                  md="12"
                  class="px-0 py-2"
                  v-for="(post, index) in $root.storeState.feedPosts"
                  :key="post.id"
                >
                  <v-card
                    class="premium-card-elevated animate-fadeInUp"
                    :class="'delay-' + ((index % 5) + 1)"
                  >
                    <!-- Video Player -->
                    <div v-if="post.type === 'video'" style="position: relative">
                       <video-player
                        class="video-player-box vjs-big-play-centered custom-video-player"
                        :options="getVideoOptions(post.videoSrc)"
                        @play="hideVideoDesc(post.id)"
                      />
                      <p class="video-js-desc" :id="'desc-' + post.id" v-if="post.duration">
                        {{ post.duration }}
                      </p>
                    </div>

                    <!-- Text Post Image -->
                    <v-img v-if="post.type === 'image'" :src="post.imageSrc" height="300" class="bg-grey"></v-img>

                    <v-card-text>
                      <v-row justify="space-between" align="center" class="pa-3 pb-0">
                        <div>
                          <span class="font-weight-medium" style="font-size: 14px" v-if="post.views">
                            {{ post.views }} views
                          </span>
                        </div>
                        <div class="d-flex align-center">
                          <v-btn icon small class="mx-1" @click="$root.store.likePost(post.id)">
                            <v-img width="22" height="22" src="../assets/applaud.svg" alt="applaud" />
                          </v-btn>
                          <span class="caption mr-3">{{ post.likes || 0 }}</span>

                          <v-btn small icon class="mx-1" @click="toggleComments(post.id)">
                            <v-icon size="20" :color="activeCommentPost === post.id ? '#f69227' : '#707070'">mdi-comment-text-outline</v-icon>
                          </v-btn>
                          <span class="caption mr-3">{{ post.comments || 0 }}</span>

                          <v-btn small icon @click="shareDialog = true">
                            <v-icon size="20" color="#707070">mdi-share-outline</v-icon>
                          </v-btn>
                        </div>
                      </v-row>

                      <v-list class="pa-0">
                        <v-list-item class="pl-0 ml-0">
                          <v-list-item-avatar>
                            <v-avatar size="42">
                              <img :src="post.avatar" alt="avatar" />
                            </v-avatar>
                          </v-list-item-avatar>
                          <v-list-item-content>
                            <v-list-item-title class="font-weight-bold" style="font-size: 14px">
                              {{ post.publisher }}
                            </v-list-item-title>
                            <v-list-item-subtitle style="font-size: 12px">
                              {{ post.university }}
                            </v-list-item-subtitle>
                          </v-list-item-content>
                          <v-spacer></v-spacer>
                          <div class="d-flex align-center caption grey--text">
                            <v-icon x-small class="mr-1" color="grey">mdi-clock-outline</v-icon>
                            {{ post.date }}
                          </div>
                        </v-list-item>
                      </v-list>
                      <p style="font-size: 14px; line-height: 1.6; color: #333" class="mb-0 mt-1 pb-2">
                        {{ post.caption }}
                      </p>
                      
                      <!-- Comments Section -->
                      <v-expand-transition>
                        <div v-if="activeCommentPost === post.id" class="pt-3 border-top mt-2">
                          <v-divider class="mb-3"></v-divider>
                          
                          <div v-if="post.commentsList && post.commentsList.length > 0" class="mb-3">
                            <div v-for="(comment, cIdx) in post.commentsList" :key="cIdx" class="d-flex align-start mb-3">
                              <v-avatar size="28" class="mr-2 mt-1">
                                <img :src="comment.avatar" />
                              </v-avatar>
                              <div class="grey lighten-4 rounded-lg pa-2 flex-grow-1">
                                <div class="d-flex justify-space-between align-center">
                                  <span class="font-weight-bold" style="font-size: 12px">{{ comment.user }}</span>
                                  <span class="grey--text caption" style="font-size: 10px">{{ comment.time }}</span>
                                </div>
                                <div style="font-size: 13px">{{ comment.text }}</div>
                              </div>
                            </div>
                          </div>
                          
                          <div class="d-flex align-center">
                            <v-avatar size="32" class="mr-2">
                              <img :src="$root.store.getUserAvatar()" />
                            </v-avatar>
                            <v-text-field
                              v-model="commentText"
                              dense outlined rounded hide-details
                              placeholder="Write a comment..."
                              color="#f69227"
                              @keyup.enter="submitComment(post.id)"
                            >
                              <template v-slot:append>
                                <v-btn icon small class="mt-n1" color="#f69227" @click="submitComment(post.id)" :disabled="!commentText.trim()">
                                  <v-icon>mdi-send</v-icon>
                                </v-btn>
                              </template>
                            </v-text-field>
                          </div>
                        </div>
                      </v-expand-transition>
                    </v-card-text>
                  </v-card>
                </v-col>
                
                <!-- Empty State -->
                <v-col cols="12" class="text-center pa-10" v-if="$root.storeState.feedPosts.length === 0">
                  <v-icon size="64" color="grey lighten-2">mdi-post-outline</v-icon>
                  <h3 class="mt-4 grey--text text--darken-1 font-weight-medium">No posts yet</h3>
                  <p class="grey--text caption">Follow users or join groups to see content here. Or be the first to post!</p>
                </v-col>
              </div>
            </v-col>

            <!-- Right Column -->
            <v-col cols="12" lg="3" md="3" class="hidden-sm-and-down">
              <RightMenu />
            </v-col>
          </v-row>
        </v-container>
      </v-main>
    </v-app>

    <!-- Create Post Dialog -->
    <v-dialog v-model="postDialog" max-width="600" persistent>
      <v-card class="premium-card">
        <v-card-title class="headline d-flex align-center py-4 px-5">
          <span style="font-weight: 700; font-size: 20px">Create a Post</span>
          <v-spacer></v-spacer>
          <v-btn icon @click="postDialog = false"><v-icon>mdi-close</v-icon></v-btn>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text class="pa-5">
          <v-form ref="postForm">
            <v-row>
              <v-col cols="12" class="py-1">
                <v-textarea v-model="newPost.caption" label="What do you want to share?" placeholder="Type your thoughts, lecture notes, or questions..." outlined auto-grow rows="4" rounded color="#f69227" hide-details></v-textarea>
              </v-col>
              <v-col cols="12" class="py-1 mt-2">
                 <v-file-input
                  v-model="newPost.videoFile"
                  accept="video/mp4, video/webm"
                  label="Upload Local Video (Optional)"
                  placeholder="Select a video file"
                  outlined
                  dense
                  rounded
                  prepend-icon=""
                  prepend-inner-icon="mdi-video"
                  color="#f69227"
                  hide-details
                ></v-file-input>
              </v-col>
            </v-row>
          </v-form>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions class="pa-4 bg-light">
          <v-btn icon color="primary"><v-icon>mdi-image-outline</v-icon></v-btn>
          <v-btn icon color="error"><v-icon>mdi-youtube</v-icon></v-btn>
          <v-btn icon color="info"><v-icon>mdi-file-document-outline</v-icon></v-btn>
          <v-spacer></v-spacer>
          <v-btn text class="text-capitalize px-4" @click="postDialog = false" rounded>Cancel</v-btn>
          <v-btn color="#f69227" class="white--text text-capitalize px-6" rounded elevation="2" :loading="isPosting" :disabled="!newPost.caption" @click="submitPost">
            Post
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Share Dialog -->
    <v-dialog v-model="shareDialog" max-width="400">
      <v-card class="premium-card pa-2">
        <v-card-title class="headline d-flex align-center pb-2">
          <span style="font-weight: 700; font-size: 18px">Share via</span>
          <v-spacer></v-spacer>
          <v-btn icon @click="shareDialog = false" small><v-icon>mdi-close</v-icon></v-btn>
        </v-card-title>
        <v-card-text class="pt-4 pb-6 d-flex justify-space-around">
           <v-btn fab color="#1877F2" dark elevation="2" class="hover-scale"><v-icon large>mdi-facebook</v-icon></v-btn>
           <v-btn fab color="#1DA1F2" dark elevation="2" class="hover-scale"><v-icon large>mdi-twitter</v-icon></v-btn>
           <v-btn fab color="#25D366" dark elevation="2" class="hover-scale"><v-icon large>mdi-whatsapp</v-icon></v-btn>
           <v-btn fab color="#0077b5" dark elevation="2" class="hover-scale"><v-icon large>mdi-linkedin</v-icon></v-btn>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import LeftMenu from "../components/Home_Screen/Left_sideMenu";
import RightMenu from "../components/Home_Screen/Right_sideMenu";

export default {
  name: "Home",
  components: {
    LeftMenu,
    RightMenu,
  },
  data: () => ({
    postDialog: false,
    shareDialog: false,
    isPosting: false,
    newPost: {
      caption: "",
      videoFile: null
    },
    activeCommentPost: null,
    commentText: ""
  }),
  computed: {
    firstName() {
      const name = this.$root.storeState.currentUser.name;
      return name ? name.split(' ')[0] : 'Student';
    }
  },
  methods: {
    getVideoOptions(src) {
      return {
        autoplay: false,
        controls: true,
        fluid: true,
        preload: 'metadata',
        poster: 'https://images.unsplash.com/photo-1456513080510-7bf3a84b82f8?w=800&h=450&fit=crop', // Educational book image
        sources: [{ src: src, type: src.endsWith('.mp4') ? 'video/mp4' : 'video/webm' }],
        controlBar: {
          fullscreenToggle: true,
        }
      };
    },
    hideVideoDesc(id) {
      const el = document.getElementById('desc-' + id);
      if (el) el.classList.add("hide");
    },
    toggleComments(id) {
      if (this.activeCommentPost === id) {
        this.activeCommentPost = null;
      } else {
        this.activeCommentPost = id;
        this.commentText = "";
      }
    },
    submitComment(id) {
      if (!this.commentText.trim()) return;
      this.$root.store.addComment(id, this.commentText);
      this.commentText = "";
      this.$root.showSnackbar("Comment added!", "#43a047", "mdi-check-circle");
    },
    submitPost() {
      if (!this.newPost.caption) return;
      this.isPosting = true;
      
      setTimeout(() => {
        let videoSrc = null;
        if (this.newPost.videoFile) {
          // Create an object URL for the local file
          videoSrc = URL.createObjectURL(this.newPost.videoFile);
        }

        const post = {
          id: 'p' + Date.now(),
          publisher: this.$root.storeState.currentUser.name,
          university: this.$root.storeState.currentUser.school || 'janguAsk User',
          avatar: this.$root.store.getUserAvatar(),
          date: 'Just now',
          likes: 0,
          comments: 0,
          caption: this.newPost.caption,
          type: videoSrc ? 'video' : 'text',
          videoSrc: videoSrc
        };
        
        this.$root.store.addPost(post);
        
        this.isPosting = false;
        this.postDialog = false;
        this.newPost.caption = "";
        this.newPost.videoFile = null;
        this.$root.showSnackbar("Your post is live!", "#43a047", "mdi-check-circle");
      }, 1000);
    }
  },
};
</script>

<style>
.custom__bg {
  background: #f5f5f5;
}
.bg-light {
  background-color: #fafbfc !important;
}

p.video-js-desc {
  position: absolute;
  bottom: 4rem;
  right: 0;
  color: black;
  z-index: 9;
  background-color: rgba(255, 255, 255, 0.95);
  border-top-left-radius: 8px;
  border-bottom-left-radius: 8px;
  padding: 6px 12px;
  font-size: 0.8rem;
  font-weight: 600;
  transition: all 0.4s ease;
  backdrop-filter: blur(4px);
}

.video-js-desc.hide {
  opacity: 0;
}

.feed-scroll-container {
  height: 100vh;
  overflow-y: auto;
  overflow-x: hidden;
  padding-right: 8px; /* For scrollbar */
}

.feed-scroll-container::-webkit-scrollbar {
  width: 6px;
}

.feed-scroll-container::-webkit-scrollbar-thumb {
  background-color: rgba(0, 0, 0, 0.1);
  border-radius: 10px;
}

/* Glassmorphic Play Button for Vue Video Player */
.custom-video-player .vjs-big-play-button {
  background: rgba(246, 146, 39, 0.9) !important;
  backdrop-filter: blur(8px) !important;
  border-radius: 50% !important;
  border: 3px solid rgba(255, 255, 255, 0.7) !important;
  width: 80px !important;
  height: 80px !important;
  line-height: 76px !important;
  top: 50% !important;
  left: 50% !important;
  margin-top: -40px !important;
  margin-left: -40px !important;
  transition: all 0.3s cubic-bezier(0.25, 0.8, 0.25, 1) !important;
  box-shadow: 0 4px 15px rgba(246, 146, 39, 0.4) !important;
}

.custom-video-player:hover .vjs-big-play-button {
  background: rgba(246, 146, 39, 1) !important;
  transform: scale(1.15) !important;
  box-shadow: 0 6px 20px rgba(246, 146, 39, 0.6) !important;
}

.custom-video-player .vjs-icon-placeholder:before {
  font-size: 45px;
  line-height: 76px;
  text-shadow: 0 2px 4px rgba(0,0,0,0.3);
}

.video-js {
  border-radius: 12px 12px 0 0;
  overflow: hidden;
}

/* Ensure fullscreen works without clipping */
.video-js.vjs-fullscreen {
  border-radius: 0 !important;
}

/* Style control bar */
.custom-video-player .vjs-control-bar {
  background: linear-gradient(transparent, rgba(0,0,0,0.7)) !important;
  border-radius: 0 0 12px 12px;
}

/* Remove grey loading box / poster */
.custom-video-player .vjs-poster {
  background-color: #111 !important;
}
</style>
